import { Chip } from 'ui';

import { formatLoadStatus } from '../../utils/formatLoadStatus';

const getStatusColor = (status?: string) => {
  if (status === 'Present') {
    return 'info';
  }

  if (status === 'Not needed') {
    return 'default';
  }

  if (status === 'Unassigned') {
    return 'warning';
  }
  return 'default';
};

export const LoadStatusChip = ({ status }: { status?: string }) => {
  return <Chip size="small" label={formatLoadStatus(status)} color={getStatusColor(status)} />;
};
